import { formatNumberCoords } from '../utils/functions';
const salford = [
  53.41619586402196,
  -2.4508005160198154,
  53.428471270706744,
  -2.421618081937784,
  53.44687773606615,
  -2.410288431058878,
  53.46057515032911,
  -2.3934656161174717,
  53.47426814704958,
  -2.354326822172159,
  53.480806527183724,
  -2.3244577425823154,
  53.46522710413682,
  -2.281542398344034,
  53.473810349702454,
  -2.2643762606487217,
  53.4774883521777,
  -2.2602563876018467,
  53.48606911825489,
  -2.2451501864299717,
  53.48831617496283,
  -2.2461801546916904,
  53.49893701345271,
  -2.2561365145549717,
  53.503225444219844,
  -2.2520166415080967,
  53.50192748281598,
  -2.246771182691072,
  53.50601142434549,
  -2.2460845371832594,
  53.508053247568334,
  -2.249861087476228,
  53.51172828150768,
  -2.245741214429353,
  53.5160154183426,
  -2.2502044102301344,
  53.51826088834924,
  -2.2584441563238844,
  53.51621955689703,
  -2.276983585034822,
  53.51131996014028,
  -2.2903731724371656,
  53.51540299677832,
  -2.293463077222322,
  53.51683196665933,
  -2.3023894688238844,
  53.52193503712857,
  -2.303419437085603,
  53.52724157839754,
  -2.311659183179353,
  53.52703749294895,
  -2.324018802319978,
  53.53099514880578,
  -2.3339751621832594,
  53.536708635700606,
  -2.343244876538728,
  53.5373207492873,
  -2.3490813633551344,
  53.531199215184024,
  -2.3545745274176344,
  53.52977072988612,
  -2.3518279453863844,
  53.52670952770737,
  -2.3545745274176344,
  53.52956665662446,
  -2.3710540196051344,
  53.53242359280332,
  -2.3892501255621656,
  53.53772882009536,
  -2.3974898716559156,
  53.53830944315786,
  -2.4116190686785077,
  53.54136980688138,
  -2.4239786878191327,
  53.54177783866274,
  -2.436681629713664,
  53.53749330880114,
  -2.4414881482683515,
  53.52933109992972,
  -2.4428614392839765,
  53.526065775843456,
  -2.451787830885539,
  53.52116731768188,
  -2.4253519788347577,
  53.515247591622035,
  -2.4171122327410077,
  53.506876912397374,
  -2.420202137526164,
  53.50422244935908,
  -2.4315317884050702,
  53.49482839918253,
  -2.436681629713664,
  53.47174287300015,
  -2.437901839304293,
  53.465816243075324,
  -2.4372151937964803,
  53.46275042011274,
  -2.462964400339449,
  53.46254602404285,
  -2.476697310495699,
  53.45886672650821,
  -2.4866536703589803,
  53.455289325997065,
  -2.486482008982027,
  53.4537560620873,
  -2.4815038290503866,
  53.44874701418929,
  -2.476353987741793,
  53.444146347762725,
  -2.478070601511324,
  53.43923842102724,
  -2.4715474691871053,
  53.436988765129946,
  -2.4663976278785116,
  53.436579723988864,
  -2.461591109323824,
  53.43187546786605,
  -2.457471236276949,
  53.428398074304596,
  -2.454381331491793,
  53.42492039624643,
  -2.450261458444918,
  53.41816879724431,
  -2.451978072214449,
];

export const salfordAreaCoords = formatNumberCoords(salford);
